import {
    GET_ALL_FEEDBACK_REQUEST,
    GET_SPECIFIC_FEEDBACK_REQUEST
} from '../actions/types';

/**
 * initial state
 */
const INIT_STATE = {
    feedbackRequests: [],
    currentFeedbackRequest: [],
    pagination: {
        current: 1,
        total: 0, // total records
        defaultPageSize: 30
    }
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_ALL_FEEDBACK_REQUEST: {
            return {
                ...state,
                feedbackRequests: action.payload?.data || [],
                pagination: {
                    current: parseInt(action.payload.current_page),
                    total: parseInt(action.payload.total),
                    defaultPageSize: parseInt(action.payload.per_page),
                }
            };
        }
        case GET_SPECIFIC_FEEDBACK_REQUEST:
            return {
                ...state,
                currentFeedbackRequest: action.payload
            };
        default:
            return { ...state };
    }
};
